var _mask, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_556_2084",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 2C24 0.895431 23.1046 0 22 0H2C0.895431 0 0 0.89543 0 2V19C0 20.1046 0.895432 21 2 21H6.44828C7.65083 21 8.58147 22.0536 8.43297 23.247L8.16829 25.3739C7.93179 27.2743 10.2441 28.3884 11.583 27.0191L16.8799 21.6018C17.2562 21.2169 17.7717 21 18.31 21H22C23.1046 21 24 20.1046 24 19V2Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8799 21.6018L18.31 23L16.8799 21.6018ZM8.16829 25.3739L6.1836 25.1269L8.16829 25.3739ZM2 2H22V-2H2V2ZM2 19V2H-2V19H2ZM6.44828 19H2V23H6.44828V19ZM10.153 25.6209L10.4177 23.494L6.44828 23L6.1836 25.1269L10.153 25.6209ZM15.4499 20.2035L10.153 25.6209L13.013 28.4173L18.31 23L15.4499 20.2035ZM22 19H18.31V23H22V19ZM22 2V19H26V2H22ZM22 23C24.2091 23 26 21.2091 26 19H22V23ZM18.31 23V19C17.2335 19 16.2025 19.4339 15.4499 20.2035L18.31 23ZM6.1836 25.1269C5.7106 28.9278 10.3353 31.1559 13.013 28.4173L10.153 25.6209C10.1435 25.6306 10.1374 25.6353 10.1354 25.6367C10.1334 25.6382 10.134 25.6376 10.1371 25.636C10.1403 25.6344 10.1445 25.6326 10.1496 25.631C10.1546 25.6294 10.1593 25.6284 10.1633 25.6278C10.1714 25.6266 10.1742 25.6275 10.1712 25.627C10.1679 25.6265 10.1612 25.6248 10.153 25.6209C10.1448 25.6169 10.1393 25.6127 10.1368 25.6104C10.1345 25.6084 10.137 25.6101 10.1411 25.6171C10.1432 25.6206 10.1453 25.625 10.1472 25.6298C10.1491 25.6348 10.1503 25.6392 10.151 25.6427C10.1517 25.6462 10.1516 25.647 10.1515 25.6445C10.1514 25.642 10.1513 25.6343 10.153 25.6209L6.1836 25.1269ZM6.44828 23L6.44828 23L10.4177 23.494C10.7147 21.1073 8.85339 19 6.44828 19V23ZM-2 19C-2 21.2091 -0.209137 23 2 23V19H2H-2ZM22 2H26C26 -0.209138 24.2091 -2 22 -2V2ZM2 -2C-0.209139 -2 -2 -0.209139 -2 2H2V2V-2Z",
    fill: "white",
    mask: "url(#path-1-inside-1_556_2084)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.94043 13.7021H19.0552",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.94043 6.85107H19.0552",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.6cf78b0b6963a1b3b80ee58a0615d0eb.svg";
export { ForwardRef as ReactComponent };